import { Component } from '@ecs/Component';
import { EnemyBehavior } from '@/types';

export class AI implements Component {
  readonly type = 'AI';

  constructor(
    public behavior: EnemyBehavior = 'hunt',
    public behaviorTimer: number = 0,
    public targetEntityId: number | null = null,
    public shootCooldown: number = 3000,
    public lastShot: number = 0
  ) {}
}